<template>
  <div class="manhole_gis">
    <div class="amap-page-container">
      <div class="lamp-search">
        <i class="el-icon-search"></i>
        <el-select
          v-model="selectedOne"
          :placeholder="$t('device.please_name')"
          filterable
          clearable
          @change="selectChange"
        >
          <el-option
            v-for="lamp in markers"
            :key="lamp.id"
            :label="lamp.title"
            :value="lamp.id"
          >
          </el-option>
        </el-select>
      </div>
      <el-amap
        ref="bmap"
        vid="bmapDemo"
        :center="center"
        :zoom="zoom"
        class="bmap-box"
        mapStyle="amap://styles/light"
      >
        <el-amap-marker
          v-for="(marker, index) in markers"
          :key="index"
          :position="[Number(marker.lng), Number(marker.lat)]"
          :icon="marker.url"
          :offset="[-20, -20]"
          :events="{ click: () => markerClick(marker) }"
          :vid="index"
          :title="marker.title"
        >
        </el-amap-marker>
        <el-amap-info-window
          :position="currentWindow.position"
          :visible="currentWindow.visible"
          :events="{ close: () => close() }"
        >
          <!-- closeWhenClickMap=true> -->
          <div>
            <h3 class="info-title" :title="messInfo.title">
              {{ messInfo.title }}
            </h3>
            <div class="info-content">
              <div v-html="getValue(messInfo)"></div>
            </div>
          </div>
        </el-amap-info-window>
      </el-amap>
    </div>
    <div class="btn_log" v-if="map_right.btn_visible" @click="btnLog">
      <img src="@/assets/images/jinggai_log_btn.png" />
    </div>
    <div class="map_right" v-if="map_right.box_visible">
      <div class="right_head">
        {{$t('manhole.warn_log')}}
        <div class="close_log" @click="closeLog">
          <img src="@/assets/images/jinggai_jiantou.png" />
        </div>
      </div>
      <el-table
        :header-cell-style="{
          backgroundColor: 'transparent',
          color: '#fff',
          fontSize: '14px',
          textAlign: 'center',
        }"
        :cell-style="{
          color: '#fff',
          backgroundColor: 'transparent',
          fontSize: '13px',
          textAlign: 'center',
        }"
        :row-style="{
          color: '#fff',
          backgroundColor: 'transparent',
          fontSize: '13px',
          textAlign: 'center',
        }"
        :data="tableData"
        stripe
        class="mytable"
      >
        <el-table-column prop="deviceId" :label="$t('manhole.communicatio_id')"></el-table-column>
        <el-table-column prop="data" :label="$t('manhole.describe')"></el-table-column>
        <el-table-column prop="type" :label="$t('device.state')" width="50">
          <template slot-scope="scope">
            <font :style="'color:' + steArrColor2[scope.row.type]">{{
              steArr[scope.row.type]
            }}</font>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('control.time')" width="120">
          <template slot-scope="scope">
            {{ scope.row.createTime.slice(5).replace("-", "/") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import manholeListApi from "@/api/manhole/manholeList";
import manholeLogApi from "@/api/manhole/manholeLog";
import { ACCOUNT_MAP } from '@/config/index.js';
export default {
  data() {
    return {
      tableData: [],
      steArr: this.$t('manhole.steArr'),
      steArrColor: ["#3ba631", "#f32f28", "#f32f28", "#3ba631"],
      steArrColor2: ["#83fd78", "#f32f28", "#f32f28", "#83fd78"],
      waterArr: this.$t('manhole.waterArr'),
      waterArrColor: ["#3ba631", "#f32f28", "#f32f28", "#f32f28"],
      selectedOne: "",
      zoom: 18,
      center: [],
      markers: [],
      // gateways: [],
      radius: 10,
      fillOpacity: 1,
      messInfo: {},
      currentWindow: {
        position: [],
        visible: false,
      },
      map_right: {
        box_visible: true,
        btn_visible: false,
      }
    };
  },
  created() {
    let mapData = ACCOUNT_MAP
    const mapDataStr = localStorage.getItem('mapData');
    if(mapDataStr){
      mapData = JSON.parse(mapDataStr)
    }
    this.center = mapData.center
    this.currentWindow.position = mapData.center

    this.getManhole();
    this.getWarn();
  },
  watch: {
    tableData() {
      this.timer();
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    getValue(items) {
      //console.log("items", items);
      let onlineArr = this.$t('device.steList');
      let onlineArrColor = ["#f32f28", "#3ba631"];
      let sheArr = this.$t('manhole.sheArr');
      let sheArrColor = ["#d0a702", "#3ba631"];
      let itemStr = this.$t('manhole.communicatio_id')+"：" + items.deviceId + "<br/>";
      itemStr += "IMEI：" + items.imei + "<br/>";
      itemStr += "IMSI：" + items.imsi + "<br/>";
      itemStr += this.$t('manhole.temp')+"：" + items.temp + "<br/>";
      itemStr += this.$t('manhole.battery')+"：" + items.power + "<br/>";
      itemStr +=
        this.$t('manhole.water_level')+'：<font style="color:' +
        this.waterArrColor[parseInt(items.water)] +
        '">' +
        this.waterArr[parseInt(items.water)] +
        "</font><br/>";
      itemStr +=
        this.$t('manhole.presence')+'：<font style="color:' +
        onlineArrColor[parseInt(items.online)] +
        '">' +
        onlineArr[parseInt(items.online)] +
        "</font><br/>";
      itemStr +=
        this.$t('manhole.defense_status')+'：<font style="color:' +
        sheArrColor[parseInt(items.she)] +
        '">' +
        sheArr[parseInt(items.she)] +
        "</font><br/>";
      itemStr +=
        this.$t('manhole.device_status')+'：<font style="color:' +
        this.steArrColor[parseInt(items.ste)] +
        '">' +
        this.steArr[parseInt(items.ste)] +
        "</font><br/>";
      return itemStr;
    },
    selectChange(value) {
      if (value) {
        //根据Id获取井盖信息
        manholeListApi.manholeInfo(value).then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data;
            this.markerClick(resData);
          }
        });
      } else {
        return value;
      }
    },
    getManhole() {
      manholeListApi.manholeList({
        page: 1,
        pageSize: 1000,
      }).then((res) => {
        if (res.data.code === 1000) {
          this.markers = res.data.data.list;
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    markerClick(marker) {
      //console.log("markerClick", marker);
      this.messInfo = marker;
      this.currentWindow.visible = true;
      this.currentWindow.position = [Number(marker.lng), Number(marker.lat)];
      setTimeout(function () {
        this.center = [Number(marker.lng), Number(marker.lat)];
      }, 200);
    },
    close() {
      this.currentWindow.visible = false;
    },
    getWarn() {
      manholeLogApi
        .manholeLogList({
          page: 1,
          pageSize: 8,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data;
            //console.log("getWarn", resData);
            this.tableData = resData.list;
          }
        });
    },
    closeLog() {
      this.map_right.box_visible = false;
      this.map_right.btn_visible = true;
    },
    btnLog() {
      this.map_right.box_visible = true;
      this.map_right.btn_visible = false;
    },
    // 这是一个定时器
    timer() {
      return setTimeout(() => {
        this.getManhole();
        this.getWarn();
      }, 5000);
    },
  }
};
</script>
<style lang='less'>
.manhole_gis{
  color: #333;
  .amap-page-container {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .lamp-search {
    position: fixed !important;
    top: 1rem;
    left: 50%;
    transform: translate(-50%, 85px);
    transition: transform 0.5s;
    z-index: 200;
  }
  .lamp-search .el-icon-search {
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 200;
    color: #fff;
  }
  .lamp-search .el-icon-search + .el-select input {
    padding-left: 32px;
  }
  .lamp-search .el-icon-search + .el-select .el-icon-caret-top {
    display: none;
  }
  .bmap-box {
    height: 100%;
    width: 100%;
  }
  
  h3.info-title {
    margin: 5px 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color:#111 !important;
  }
  .info-content {
    margin: 5px 0;
    overflow: hidden;
    color:#333 !important;
  }
  .info-content span {
    width: 150px;
    float: left;
  }
  .info-controls {
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 10px;
    outline: none;
  }
  .info-controls button {
    border: 1px solid rgba(51, 153, 204, 0.5);
    border-radius: 50%;
    background-size: 30px;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    width: 50px;
    height: 50px;
    line-height: 1.2em;
    margin: 0 10px 25px 0;
    box-sizing: border-box;
    cursor: pointer;
    float: left;
    font-size: 18px;
    outline: none;
  }
  .info-controls button:after {
    content: attr(data-text);
    display: inline-block;
    font-size: 12px;
    position: absolute;
    top: 55px;
    left: 0;
    right: 0;
    text-align: center;
  }
  .info-controls button.btn-lamp-control {
    background-image: url(../../../assets/svg/lamp-control.svg);
  }
  .info-controls button.btn-video-preview {
    background-image: url(../../../assets/svg/video-preview.svg);
  }
  .lamp-search input {
    border: none;
    background-color: rgba(0, 0, 0, 0.6);
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    color: rgb(255, 255, 255);
    min-width: 300px;
  }
  .lamp-search input::-webkit-input-placeholder {
    color: white;
  }
  .lamp-search input:focus,
  .lamp-search input:hover {
    border-color: transparent;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .text-wrapper {
    white-space: pre-wrap;
  }


  .map_right {
    position: absolute;
    top: 20px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    color: #fff;
    z-index: 2;
    width: 360px;
    right: 38px;
    left: auto;
    padding: 20px 15px;
    font-size: 12px;
    line-height: 24px;
  }
  .right_head {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    margin-bottom: 0;
  }
  .close_log {
    position: absolute;
    right: 15px;
    top: 20px;
    cursor: pointer;
  }
  .close_log img {
    width: 20px;
    height: 20px;
  }
  .btn_log {
    cursor: pointer;
    width: 44px;
    height: 44px;
    background: #168bfe;
    position: absolute;
    right: 38px;
    top: 98px;
    z-index: 9999;
    border-radius: 44px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
    box-shadow: 0 0 8px rrgba(73, 58, 58, 0.15);
  }
  .btn_log img {
    width: 24px;
    height: 24px;
  }
  
}
</style>
<style>
.mytable,
  .mytable th,
  .mytable tr {
    background: transparent !important;
  }
  .mytable th {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3) !important;
    padding: 8px 0 !important;
  }
  .mytable td {
    padding: 8px 0 !important;
    border: 0 !important;
  }
  .mytable .cell {
    padding: 0 5px !important;
  }
  .mytable::before {
    background: transparent !important;
  }
</style>